<script>
export default {
  name: 'CommentDisplay',
  props: {
    commentText: {
      type: String,
      default: '',
    },
    displayMode: {
      type: String,
      default: 'text',
      validator: (value) => {
        return ['text', 'icon'].includes(value)
      },
    },
    tooltipMaxWidth: {
      type: [String, Number],
      default: 400,
    },
    hasExtraContent: {
      type: Boolean,
      default: false,
    },
    isHovering: {
      type: Boolean,
      default: false,
    },
    emptyTooltipLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasVisibleComment() {
      if (typeof this.commentText !== 'string') {
        return false
      }
      return !!this.commentText.trim()
    },
    resolvedTooltipText() {
      if (this.displayMode === 'icon' && !this.hasVisibleComment) {
        return this.emptyTooltipLabel || ''
      }
      return this.commentText || ''
    },
    resolvedTooltipStyle() {
      const numericWidth = typeof this.tooltipMaxWidth === 'number'
      const widthValue = numericWidth
        ? `${this.tooltipMaxWidth}px`
        : this.tooltipMaxWidth
      return {
        maxWidth: widthValue,
        whiteSpace: 'normal',
      }
    },
    resolvedIconColor() {
      if (this.hasVisibleComment) {
        return 'primary'
      }
      return '#8E8E8E'
    },
    resolvedIconVisibility() {
      if (this.hasVisibleComment) {
        return 'visible'
      }
      if (this.hasExtraContent) {
        return 'visible'
      }
      if (this.isHovering) {
        return 'visible'
      }
      return 'hidden'
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<template>
  <div class="comment-display">
    <div v-if="displayMode === 'text'">
      <div v-if="hasVisibleComment">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="text-truncate text-sm comment-display__text"
              v-bind="attrs"
              v-on="on"
            >
              {{ commentText }}
            </div>
          </template>

          <div class="comment-display__tooltip" :style="resolvedTooltipStyle">
            {{ resolvedTooltipText }}
          </div>
        </v-tooltip>
      </div>
      <div v-else> - </div>
    </div>

    <div v-else-if="displayMode === 'icon'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            class="comment-display__icon-btn"
            :style="{ visibility: resolvedIconVisibility }"
            v-bind="attrs"
            v-on="on"
            @click.stop="handleClick"
          >
            <icon-svg
              :color="resolvedIconColor"
              size="16"
              name="mdi-note-edit-outline"
            />
          </v-btn>
        </template>

        <div class="comment-display__tooltip" :style="resolvedTooltipStyle">
          {{ resolvedTooltipText }}
        </div>
      </v-tooltip>
    </div>

    <div v-else> - </div>
  </div>
</template>

<style lang="sass" scoped>
.comment-display
  &__text
    max-width: 300px

  &__tooltip
    white-space: normal

  &__icon-btn
    min-width: 24px
    height: 24px
    padding: 0
</style>
